'use client';

import React from 'react';

interface HorizontalCarouselProps {
  items: string[];
  title?: string;
  itemClassName?: string;
  containerClassName?: string;
  gap?: string;
  duration?: number;
}

export default function HorizontalCarousel({
  items,
  title,
  itemClassName = 'w-32 sm:w-40 h-16 sm:h-24',
  containerClassName = '',
  gap = '2rem',
  duration = 30,
}: HorizontalCarouselProps) {
  // Duplica gli items per creare un loop seamless
  const duplicatedItems = [...items, ...items];

  return (
    <div className={`w-full overflow-hidden z-10 ${containerClassName}`}>
      {title && (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-5">
          <h4 className="sm:text-start text-center text-[#333333] mb-5">
            {title}
          </h4>
        </div>
      )}
      <div className="relative w-full overflow-hidden">
        <div
          className="flex animate-scroll-infinite"
          style={{
            width: 'fit-content',
            gap: gap,
            animationDuration: `${duration}s`,
          } as React.CSSProperties}
        >
          {duplicatedItems.map((item, i) => (
            <img
              key={i}
              style={{ objectFit: 'contain', flexShrink: 0 }}
              src={item}
              alt={`Item #${(i % items.length) + 1}`}
              className={itemClassName}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
